import { useState, useCallback, useEffect, useRef } from 'react';
import Button from 'src/componentes/button';
import Dialog from 'src/componentes/dialog';
import jsxArray from 'src/utils/jsx-array';
import { ButtonToolbar } from 'reactstrap';
import { KEYS } from 'src/utils/keydown-decorator';
import Checkbox from 'src/componentes/checkbox';
import { capitalizeFirstLetter } from 'src/utils/string';

export default function ConfirmacaoAprovacao({
  modelPerdaOperacional = {},
  handleCancel,
  handleConfirm,
  intl,
  resources,
  ...other
}) {
  const [
    idResponsavelAreasGeradorasSelecionadas,
    setIdResponsavelAreasGeradorasSelecionadas,
  ] = useState([]);

  const dialogRef = useRef(null);

  const handleCancelClick = useCallback(() => {
    setIdResponsavelAreasGeradorasSelecionadas([]);
    handleCancel && handleCancel();
    dialogRef.current?.close();
  }, [handleCancel]);

  const handleConfirmClick = useCallback(() => {
    handleConfirm?.(idResponsavelAreasGeradorasSelecionadas);
    dialogRef.current?.close();
  }, [handleConfirm, idResponsavelAreasGeradorasSelecionadas]);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.keyCode === KEYS.ESC) {
        handleCancelClick();
      }

      if (e.keyCode === KEYS.ENTER) {
        handleConfirmClick();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [handleCancelClick, handleConfirmClick]);

  const actions = jsxArray(
    <ButtonToolbar>
      <Button onClick={handleCancelClick} color="secondary">
        {intl.formatMessage({ id: 'label.cancelar' })}
      </Button>
      <Button
        className="ml-2"
        autoFocus
        type="primary"
        onClick={handleConfirmClick}
      >
        {intl.formatMessage({ id: 'aprovar' })}
      </Button>
    </ButtonToolbar>
  );

  const areaGeradoraESuperiores = [
    modelPerdaOperacional.areaGeradora,
    ...(modelPerdaOperacional.areasSuperioresAreaGeradora ?? []),
  ].filter((area) => area != null);

  return (
    <Dialog
      {...other}
      width={700}
      ref={dialogRef}
      title={intl.formatMessage(
        { id: 'titleModalAprovacaoPerdaOperacional' },
        {
          perdaoperacional: resources.perdaoperacional,
          nomedaperdaoperacional: modelPerdaOperacional?.nome,
        }
      )}
      actions={actions}
      onRequestClose={handleCancelClick}
      padContent
    >
      <div className="mb-3">
        {intl.formatMessage(
          { id: 'msgAprovacaoPerdaOperacional' },
          { perdaoperacional: resources.perdaoperacional }
        )}
      </div>
      {modelPerdaOperacional?.exibirOpcoesNotificarAreaGeradora && (
        <>
          <div className="mb-3">
            {intl.formatMessage(
              {
                id: 'labelEscolhaQuemSeraNotificadoAprovacaoPerdaAreaGeradora',
              },
              {
                perdaoperacional: resources.perdaoperacional,
                area: resources.area,
              }
            )}
          </div>
          {areaGeradoraESuperiores.map((area, index) => {
            const checked =
              area.idResponsavel != null &&
              idResponsavelAreasGeradorasSelecionadas.includes(
                area.idResponsavel
              );
            return (
              <Checkbox
                key={area.id}
                className="mb-3"
                disabled={area.idResponsavel == null}
                model={{
                  value: checked,
                  label: capitalizeFirstLetter(
                    intl.formatMessage(
                      {
                        id:
                          index === 0
                            ? 'labelResponsavelAreaGeradoraNomeResponsavelNomeAreaGeradora'
                            : 'labelResponsavelHierarquiaAreaGeradoraNomeResponsavelNomeAreaGeradora',
                      },
                      {
                        responsavel: resources.responsavel,
                        area: resources.area,
                        nomeResponsavel:
                          area.responsavel ??
                          capitalizeFirstLetter(
                            intl.formatMessage(
                              { id: 'labelResponsavelNaoDefinido' },
                              {
                                responsavel: resources.responsavel,
                              }
                            )
                          ),
                        nomeAreaGeradora: area.nome,
                        nivel: index,
                      }
                    )
                  ),
                  requestChange: (checked) => {
                    if (area.idResponsavel == null) return;

                    setIdResponsavelAreasGeradorasSelecionadas((atual) => {
                      if (checked) {
                        return atual.includes(area.idResponsavel)
                          ? atual
                          : [...atual, area.idResponsavel];
                      }

                      return atual.filter((id) => id !== area.idResponsavel);
                    });
                  },
                }}
              />
            );
          })}
        </>
      )}
    </Dialog>
  );
}
